import { Input, validateInput, ValidationFunction } from "basis";

type FnType = ValidationFunction<typeof Input>;
export const validateLength: FnType = (value, props) => {
  const errors = validateInput(value, props);

  if (errors) {
    return errors;
  }

  if (!props.maxLength) {
    return null;
  }

  if (value.length > props.maxLength) {
    return `Must be less than ${props.maxLength} characters`;
  }

  return null;
};

const NUMERIC_ONLY = /^[0-9]+$/;

export const validatePostcode: FnType = (value, props) => {
  const validLength = validateLength(value, props);

  if (validLength) {
    return validLength;
  }

  if (NUMERIC_ONLY.test(value) === false) return "Only digits are allowed";
  return null;
};
